import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "cart-checkout__details" };
const _hoisted_2 = { class: "mb-2 ml-2" };
const _hoisted_3 = { class: "mb-4 data-box__select" };
const _hoisted_4 = { class: "item" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { style: { "display": "flex", "flex-direction": "row" } };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
    key: 0,
    style: { "flex": "1 1 auto" },
    class: "text-end"
};
const _hoisted_9 = { class: "text-muted" };
const _hoisted_10 = {
    key: 0,
    class: "item-secondary"
};
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_12 = {
    key: 1,
    class: "item-secondary"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_14 = { class: "mb-2 ml-2" };
const _hoisted_15 = { class: "mb-4 data-box__select" };
const _hoisted_16 = { class: "item" };
const _hoisted_17 = ["value"];
const _hoisted_18 = { style: { "display": "flex", "flex-direction": "row" } };
const _hoisted_19 = {
    key: 0,
    style: { "flex": "1 1 auto" },
    class: "text-end"
};
const _hoisted_20 = { class: "text-muted" };
const _hoisted_21 = {
    key: 0,
    class: "item-secondary"
};
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_23 = { class: "row" };
const _hoisted_24 = { class: "col-md-3" };
const _hoisted_25 = { class: "col-md-3" };
const _hoisted_26 = { class: "col-md-6" };
const _hoisted_27 = { class: "mb-2 ml-2" };
const _hoisted_28 = { class: "mb-4 data-box" };
const _hoisted_29 = { style: { "margin-top": "8px" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_cart_profile_login = _resolveComponent("g-cart-profile_login");
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_select_field = _resolveComponent("g-select-field");
    const _component_g_text_area = _resolveComponent("g-text-area");
    const _component_g_file_field = _resolveComponent("g-file-field");
    const _component_g_form = _resolveComponent("g-form");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_g_form, {
            ref: "frmMain",
            "data-object": _ctx.data
        }, {
            default: _withCtx(() => [
                (_ctx.schema?.profile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.MyData')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.profile, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("div", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                name: "profile",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.data.profile.mode) = $event)),
                                                value: item.name
                                            }, null, 8, _hoisted_5), [
                                                [_vModelRadio, _ctx.data.profile.mode]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", {
                                                onClick: ($event) => (_ctx.$data.data.profile.mode = item.name),
                                                style: { "cursor": "pointer" }
                                            }, _toDisplayString(item.caption), 9, _hoisted_7),
                                            (item.name === _ctx.data?.profile?.mode || !item.hideIfNotSelected)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    _createElementVNode("span", _hoisted_9, [
                                                        (item?.description)
                                                            ? (_openBlock(), _createBlock(_component_g_dynamic_html, {
                                                                key: 0,
                                                                template: item?.description
                                                            }, null, 8, ["template"]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (_ctx.data?.profile?.mode === item.name && item.detailsMode === 'login')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _hoisted_11,
                                            _createElementVNode("div", null, [
                                                _createVNode(_component_g_cart_profile_login, {
                                                    onLoggedin: _ctx.loadAfterLogin,
                                                    data: _ctx.user
                                                }, null, 8, ["onLoggedin", "data"])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (_ctx.data?.profile?.mode === item.name && (item.detailsMode === 'create' || item.detailsMode === 'guest'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _hoisted_13,
                                            _createElementVNode("div", null, [
                                                _createVNode(_component_g_dynamic_html, {
                                                    template: item.content,
                                                    "template-props": _ctx.data
                                                }, null, 8, ["template", "template-props"])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 256))
                        ])
                    ], 64))
                    : _createCommentVNode("", true),
                (_ctx.schema?.invoicing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.InvoiceAddress')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.invoicing, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                name: "invoicing",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.data.addresses.invoice.mode) = $event)),
                                                value: item.name
                                            }, null, 8, _hoisted_17), [
                                                [_vModelRadio, _ctx.data.addresses.invoice.mode]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", null, _toDisplayString(item.caption), 1),
                                            (item.name === _ctx.data?.addresses?.invoice?.mode || !item.hideIfNotSelected)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _createElementVNode("span", _hoisted_20, [
                                                        _createVNode(_component_g_dynamic_html, {
                                                            template: item.description,
                                                            templateProps: { item: item }
                                                        }, null, 8, ["template", "templateProps"])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    (_ctx.data?.addresses?.invoice?.mode === item.name && item.detailsMode === 'address')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _hoisted_22,
                                            _createElementVNode("div", null, [
                                                _createElementVNode("div", null, [
                                                    _createVNode(_component_g_text_field, {
                                                        label: "Name 1",
                                                        "data-member": "addresses.invoice.name1",
                                                        "validation-rules": { required: true }
                                                    })
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createVNode(_component_g_text_field, {
                                                        label: "Name 2",
                                                        "data-member": "addresses.invoice.name2"
                                                    })
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createVNode(_component_g_text_field, {
                                                        label: "Zusatz",
                                                        "data-member": "addresses.invoice.addition"
                                                    })
                                                ]),
                                                _createElementVNode("div", null, [
                                                    _createVNode(_component_g_text_field, {
                                                        label: "Straße",
                                                        "data-member": "addresses.invoice.street",
                                                        "validation-rules": { required: true }
                                                    })
                                                ]),
                                                _createElementVNode("div", _hoisted_23, [
                                                    _createElementVNode("div", _hoisted_24, [
                                                        _createVNode(_component_g_select_field, {
                                                            label: "Land",
                                                            "data-member": "addresses.invoice.country",
                                                            "item-source": _ctx.schema.dataSources.countries_invoice,
                                                            "value-expr": "name",
                                                            "display-expr": "caption"
                                                        }, null, 8, ["item-source"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _createVNode(_component_g_text_field, {
                                                            label: "Plz",
                                                            "data-member": "addresses.invoice.zipCode",
                                                            "data-object": _ctx.data,
                                                            "validation-rules": { required: true }
                                                        }, null, 8, ["data-object"])
                                                    ]),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _createVNode(_component_g_text_field, {
                                                            label: "Ort",
                                                            "data-member": "addresses.invoice.city",
                                                            "validation-rules": { required: true }
                                                        })
                                                    ])
                                                ])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 256))
                        ])
                    ], 64))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.AddionalData')), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema?.userData, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "item",
                            key: item.name
                        }, [
                            _createElementVNode("div", _hoisted_29, _toDisplayString(item.caption), 1),
                            _createElementVNode("div", null, [
                                (item.fieldType === 'text-area')
                                    ? (_openBlock(), _createBlock(_component_g_text_area, {
                                        key: 0,
                                        "data-member": item.dataMember,
                                        rows: 8
                                    }, null, 8, ["data-member"]))
                                    : (item.fieldType === 'file')
                                        ? (_openBlock(), _createBlock(_component_g_file_field, {
                                            key: 1,
                                            "upload-url": '/frontend/v1/commerce/checkout/' + _ctx.cart.cartID + '/files?member=' + item.dataMember,
                                            "delete-url": '/frontend/v1/commerce/checkout/' + _ctx.cart.cartID + '/files/{fileID}',
                                            "open-url": '/frontend/v1/commerce/checkout/' + _ctx.cart.cartID + '/files/{fileID}',
                                            accept: item.options?.allowedTypes ?? '*',
                                            "max-file-size": (item.options?.maxFileSize ?? 30) * 1024 * 1024,
                                            multiple: true,
                                            "data-member": 'files.' + item.dataMember,
                                            "data-mode": 'model',
                                            "data-object": _ctx.data
                                        }, null, 8, ["upload-url", "delete-url", "open-url", "accept", "max-file-size", "data-member", "data-object"]))
                                        : (_openBlock(), _createBlock(_component_g_text_field, {
                                            key: 2,
                                            "data-member": item.dataMember,
                                            "max-length": item.maxLength
                                        }, null, 8, ["data-member", "max-length"]))
                            ])
                        ]));
                    }), 128))
                ])
            ]),
            _: 1
        }, 8, ["data-object"])
    ]));
}
